export const localStorageKey = {
  token: 'token',
  cookie: 'cookie',
  privacyStatement: 'privacyStatement',
  protocolHelpPage: 'protocolHelpPage',
}
